import { FlyoutButtonComponent } from './flyout-button/flyout-button.component';

export const Components = [
	FlyoutButtonComponent,
];
